import waybillAPI from '@/api/waybill'

const types = {
  loadItems: 'loadItems',
  getAddress: 'getAddress',
  setIsLoading: 'setIsLoading',
  clearItems: 'clearItems'
}
let request = null

export default {
  namespaced: true,
  state: {
    items: null
  },
  mutations: {
    [types.loadItems] (state, { items }) {
      state.items = items
    },
    [types.setIsLoading] (state, value) {
      state.isLoading = value
    },
    [types.clearItems] (state) {
      state.items = null
    }
  },
  actions: {
    loadItems ({ state, commit, dispatch }, params) {
      if (state.isLoading) {
        dispatch('abortLoading')
      }
      if (request) {
        request.abort()
      }
      request = waybillAPI.getItems(params)
      commit(types.setIsLoading, true)
      return request.promise
        .then(params => {
          request = null
          commit(types.setIsLoading, false)
          commit(types.loadItems, params)
          return params.items
        })
    },
    getAddress ({ state, commit, dispatch }, params) {
      return waybillAPI.getAddressByCoords(params)
        .then(params => {
          return params
        })
    },
    abortLoading ({ state, commit }) {
      commit(types.setIsLoading, false)
      if (request) {
        request.abort()
        request = null
      }
    },
    clearItems ({ state, commit, dispatch }) {
      if (state.isLoading) {
        dispatch('abortLoading')
      }
      commit(types.clearItems)
    }
  }
}
